import {
    SCHIBSTED_ACCOUNT_START,
    SCHIBSTED_ACCOUNT_INIT,
    SCHIBSTED_ACCOUNT_INIT_COMPLETE,
    SCHIBSTED_ACCOUNT_HAS_SESSION,
    SCHIBSTED_ACCOUNT_HAS_SESSION_COMPLETE,
    SCHIBSTED_ACCOUNT_HAS_SESSION_ERROR,
    SCHIBSTED_ACCOUNT_LOGIN,
    SCHIBSTED_ACCOUNT_LOGOUT,
    SCHIBSTED_ACCOUNT_GENERATE_URLS,
    SCHIBSTED_ACCOUNT_SUBSCRIBE_EVENTS,

    SCHIBSTED_ACCOUNT_EVENT_NOTLOGGEDIN,
    SCHIBSTED_ACCOUNT_EVENT_STATUS_CHANGE,
    SCHIBSTED_ACCOUNT_EVENT_LOGIN,
    SCHIBSTED_ACCOUNT_EVENT_LOGOUT,
    SCHIBSTED_ACCOUNT_EVENT_USER_CHANGE,
    SCHIBSTED_ACCOUNT_EVENT_SESSION_INIT,
    SCHIBSTED_ACCOUNT_EVENT_SESSION_CHANGE,
    SCHIBSTED_ACCOUNT_EVENT_VISITOR,
    SCHIBSTED_ACCOUNT_EVENT_SESSION_ERROR,
} from './types';

export const start = config => ({
    type: SCHIBSTED_ACCOUNT_START,
    payload: config,
});

export const init = config => ({
    type: SCHIBSTED_ACCOUNT_INIT,
    payload: config,
});

export const initComplete = payload => ({
    type: SCHIBSTED_ACCOUNT_INIT_COMPLETE,
    payload,
});

export const hasSession = () => ({
    type: SCHIBSTED_ACCOUNT_HAS_SESSION,
});

export const hasSessionComplete = data => ({
    type: SCHIBSTED_ACCOUNT_HAS_SESSION_COMPLETE,
    payload: data,
});

export const hasSessionError = data => ({
    type: SCHIBSTED_ACCOUNT_HAS_SESSION_ERROR,
    payload: data,
});

export const login = data => ({
    type: SCHIBSTED_ACCOUNT_LOGIN,
    payload: data,
});

export const logout = data => ({
    type: SCHIBSTED_ACCOUNT_LOGOUT,
    payload: data,
});

export const generateUrls = urls => ({
    type: SCHIBSTED_ACCOUNT_GENERATE_URLS,
    payload: urls,
});

export const subscribeEvents = () => ({
    type: SCHIBSTED_ACCOUNT_SUBSCRIBE_EVENTS,
});

export const eventNotLoggedin = data => ({
    type: SCHIBSTED_ACCOUNT_EVENT_NOTLOGGEDIN,
    payload: data,
});

export const eventStatusChange = data => ({
    type: SCHIBSTED_ACCOUNT_EVENT_STATUS_CHANGE,
    payload: data,
});

export const eventLogin = data => ({
    type: SCHIBSTED_ACCOUNT_EVENT_LOGIN,
    payload: data,
});

export const eventLogout = data => ({
    type: SCHIBSTED_ACCOUNT_EVENT_LOGOUT,
    payload: data,
});

export const eventUserChange = data => ({
    type: SCHIBSTED_ACCOUNT_EVENT_USER_CHANGE,
    payload: data,
});

export const eventSessionInit = data => ({
    type: SCHIBSTED_ACCOUNT_EVENT_SESSION_INIT,
    payload: data,
});

export const eventSessionChange = data => ({
    type: SCHIBSTED_ACCOUNT_EVENT_SESSION_CHANGE,
    payload: data,
});

export const eventVisitor = data => ({
    type: SCHIBSTED_ACCOUNT_EVENT_VISITOR,
    payload: data,
});

export const eventSessionError = data => ({
    type: SCHIBSTED_ACCOUNT_EVENT_SESSION_ERROR,
    payload: data,
});
